import { Stack } from "@mui/material";
import { CustomModal } from "components/CustomModal";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styling";

import type { EpcUploadModalProps } from "./types";

import { MODAL_LAYOUT } from "./constants";
import { EpcModalActions } from "./EpcModalActions";
import { EPCModalContentFactory } from "./EPCModalContentFactory";

export const EpcUploadModal = ({ handlers, states }: EpcUploadModalProps) => {
  const { t } = useTranslation();

  const { handleCloseModal } = handlers;
  const { modalOpen, pendingExtraction, phase } = states;

  const layout = MODAL_LAYOUT[phase];
  const isPreview = phase === "preview" && !!pendingExtraction;

  const Components = useMemo(() => EPCModalContentFactory({ handlers, states, t }), [handlers, states, t]);
  return (
    <CustomModal
      disableBackdropClick
      height={layout.height}
      modalOpen={modalOpen}
      onClose={undefined}
      setModalOpen={handleCloseModal}
      width={layout.width}
    >
      <Stack className={cn("flex-col items-start gap-6", isPreview && "h-full overflow-hidden")}>
        <Stack className={cn("w-full flex-col", isPreview && "flex-1 overflow-hidden")}>{Components?.content}</Stack>
        <EpcModalActions actionsRows={Components?.actionsRows} />
      </Stack>
    </CustomModal>
  );
};
